import {Injectable, inject} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {toSignal} from '@angular/core/rxjs-interop';
import {filter, map, startWith} from 'rxjs';
import {RouteVisibilityPort} from "@features/wallet/application/ports/route-visibility.port";

@Injectable()
export class RouterVisibilityAdapter implements RouteVisibilityPort {

  private readonly router = inject(Router);

  readonly isOnProductsRoute = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(event => event.urlAfterRedirects.includes('/account/products')),
      startWith(this.router.url.includes('/account/products'))
    ),
    {initialValue: false}
  );
}
